// Generated from the existing public teamData.js. Keep names/photos unchanged.
import type { WebsiteLeadership } from './website-leadership';
export const DEFAULT_WEBSITE_LEADERSHIP: WebsiteLeadership = {
  "title": "Our leadership",
  "subtitle": "Office bearers, executive committee, and advisors",
  "groups": [
    {
      "id": "office-bearers",
      "members": [
        {
          "id": "office-bearers-1",
          "name": "Sudarshan Mantri",
          "position": "President",
          "photo": "/photos/sudharshan.png",
          "photoWebp": null,
          "photoPosition": "top"
        },
        {
          "id": "office-bearers-2",
          "name": "Kushal Maheswari",
          "position": "Secretary",
          "photo": "/photos/kushal.png",
          "photoWebp": null,
          "photoPosition": "top"
        },
        {
          "id": "office-bearers-3",
          "name": "Hemanth Bhathad",
          "position": "Vice President",
          "photo": "/photos/hemanth.png",
          "photoWebp": null,
          "photoPosition": "center 15%"
        },
        {
          "id": "office-bearers-4",
          "name": "Ketan Bisani",
          "position": "Vice President",
          "photo": "/photos/ketan.png",
          "photoWebp": null,
          "photoPosition": "center 25%"
        },
        {
          "id": "office-bearers-5",
          "name": "Mohit Bajaj",
          "position": "Treasurer",
          "photo": "/photos/mohit.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "office-bearers-6",
          "name": "Shubham Sarda",
          "position": "Joint Secretary",
          "photo": "/photos/shubham.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "office-bearers-7",
          "name": "Nikhil Mohta",
          "position": "Joint Secretary",
          "photo": "/photos/nikhil.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "office-bearers-8",
          "name": "Madan Mohan Rathi",
          "position": "IPP",
          "photo": "/photos/madan.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "office-bearers-9",
          "name": "Pankaj Mohata",
          "position": "IPS",
          "photo": "/photos/pankaj.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        }
      ]
    },
    {
      "id": "executive-committee",
      "members": [
        {
          "id": "executive-committee-1",
          "name": "Abhinandan Chandak",
          "position": "Executive Member",
          "photo": "/photos/abhinandan.png",
          "photoWebp": null,
          "photoPosition": "center 5%"
        },
        {
          "id": "executive-committee-2",
          "name": "Ankit Rathi",
          "position": "Executive Member",
          "photo": "/photos/ankit.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-3",
          "name": "Arnav Maheswary",
          "position": "Executive Member",
          "photo": "/photos/arnav.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-4",
          "name": "Arvind Kumar Jetha",
          "position": "Executive Member",
          "photo": "/photos/arvind.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-5",
          "name": "Ashish Maheswari",
          "position": "Executive Member",
          "photo": "/photos/ashish.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-6",
          "name": "Atul Maheswari",
          "position": "Executive Member",
          "photo": "/photos/atul.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-7",
          "name": "Chirag Jhawar",
          "position": "Executive Member",
          "photo": "/photos/chirag.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-8",
          "name": "Girish Singh Mohta",
          "position": "Executive Member",
          "photo": "/photos/girish.png",
          "photoWebp": "/photos/girish.webp",
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-9",
          "name": "Jayesh Bisani",
          "position": "Executive Member",
          "photo": "/photos/jayesh-bisani.png",
          "photoWebp": null,
          "photoPosition": "center 10%"
        },
        {
          "id": "executive-committee-10",
          "name": "Jayesh Rathi",
          "position": "Executive Member",
          "photo": "/photos/jayesh-rathi.png",
          "photoWebp": null,
          "photoPosition": "center 10%"
        },
        {
          "id": "executive-committee-11",
          "name": "Kriti Suda",
          "position": "Executive Member",
          "photo": "/photos/kriti.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-12",
          "name": "Laksh Kela",
          "position": "Executive Member",
          "photo": "/photos/laksh.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "executive-committee-13",
          "name": "Mahima Rathi",
          "position": "Executive Member",
          "photo": "/photos/mahima.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-14",
          "name": "Saakshi Chandak",
          "position": "Executive Member",
          "photo": "/photos/saakshi.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-15",
          "name": "Tapas Bhattad",
          "position": "Executive Member",
          "photo": "/photos/tapas.png",
          "photoWebp": null,
          "photoPosition": "center 5%"
        },
        {
          "id": "executive-committee-16",
          "name": "Vikramaditya Bisani",
          "position": "Executive Member",
          "photo": "/photos/vikramaditya.png",
          "photoWebp": null,
          "photoPosition": "center 15%"
        },
        {
          "id": "executive-committee-17",
          "name": "Yash Malpani",
          "position": "Executive Member",
          "photo": "/photos/yash.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "executive-committee-18",
          "name": "Yashika Malpani",
          "position": "Executive Member",
          "photo": "/photos/yashika.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        }
      ]
    },
    {
      "id": "advisors",
      "members": [
        {
          "id": "advisors-1",
          "name": "Anurag Maheshwari",
          "position": "Sabha Convener",
          "photo": "/photos/anurag.png",
          "photoWebp": null,
          "photoPosition": "center"
        },
        {
          "id": "advisors-2",
          "name": "Hari Ratan Rathi",
          "position": "Advisor",
          "photo": "/photos/hari.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "advisors-3",
          "name": "Jai Prakash Malpani",
          "position": "Advisor",
          "photo": "/photos/jaiprakash.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "advisors-4",
          "name": "Praful Mohta",
          "position": "Advisor",
          "photo": "/photos/praful.png",
          "photoWebp": null,
          "photoPosition": "center 10%"
        },
        {
          "id": "advisors-5",
          "name": "Pramod Sarda",
          "position": "Advisor",
          "photo": "/photos/pramod.png",
          "photoWebp": null,
          "photoPosition": "center 20%"
        },
        {
          "id": "advisors-6",
          "name": "Vinod Dwarkani",
          "position": "Advisor",
          "photo": "/photos/vinod.png",
          "photoWebp": null,
          "photoPosition": "center"
        }
      ]
    }
  ],
  "updatedAt": null
};
